import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const registerUserDeductions = payload =>
  call(websocketFetch, 'register_user_deduction', payload);
